exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@mixin dtb-two-stop-gradient($fromColor,$toColor){background-color:$toColor;background-image:linear-gradient(top,$fromColor,$toColor);filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,StartColorStr=\"#{nth( $fromColor, 1 )}\",EndColorStr=\"#{nth( $toColor, 1 )}\")}@mixin dtb-radial-gradient ($fromColor,$toColor){background:$toColor;background:radial-gradient(ellipse farthest-corner at center,$fromColor 0,$toColor 100%)}@mixin dtb-fixed-collection{// Fixed positioning feature &.fixed{position:fixed;top:50%;left:50%;margin-left:-75px;border-radius:0;&.two-column{margin-left:-150px}&.three-column{margin-left:-225px}&.four-column{margin-left:-300px}}//:8px;-ms-column-gap:8px;-o-column-gap:8px;column-gap:8px;>*{break-inside:avoid}&.two-column{width:300px;padding-bottom:1px;-ms-column-count:2;-o-column-count:2;column-count:2}&.three-column{width:450px;padding-bottom:1px;-ms-column-count:3;-o-column-count:3;column-count:3}&.four-column{width:600px;padding-bottom:1px;-ms-column-count:4;-o-column-count:4;column-count:4}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/datatables-buttons/css/mixins.scss
// module id = 486
// module chunks = 0